import { render, staticRenderFns } from "./PasosB.vue?vue&type=template&id=5e677615&lang=pug&"
import script from "./PasosB.vue?vue&type=script&lang=js&"
export * from "./PasosB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports